export default "__VITE_ASSET__BlN9_Gdc__"